import { Chip, ChipProps } from '@mui/material';

import styles from './Chip.module.scss';

type IChipComponentProps = ChipProps & {
	label: string;
	customcolor?: string;
	className?: any;
	defaultClass?: boolean;
	chipIcon?: any;
	color?:
		| 'default'
		| 'primary'
		| 'secondary'
		| 'error'
		| 'info'
		| 'success'
		| 'warning';
	onClick?: () => void;
};

const ChipComponent = (props: IChipComponentProps) => {
	const {
		label,
		customcolor,
		color,
		defaultClass,
		className,
		chipIcon,
		onClick,
	} = props;
	const chipcolor = customcolor ? customcolor.toLowerCase() : 'status-null';

	const defaultCssClass = styles['chip-label'];
	const customDefaultClass = styles[chipcolor];
	const customClass = color
		? defaultCssClass
		: `${defaultCssClass} ${customDefaultClass}`;

	return (
		<Chip
			size="small"
			label={label}
			color={color}
			className={defaultClass ? className : customClass}
			icon={chipIcon}
			onClick={onClick}
			sx={{
				'& .MuiChip-label': {
					paddingLeft: 1,
					paddingRight: 1,
				},
				'& .MuiChip-root': {
					borderRadius: 5,
				},
				'& .MuiChip-icon': {
					marginLeft: 1, // add some space between icon and delete icon
					width: '1.1em',
					height: '1.1em',
				},
				fontSize: 14,
				fontWeight: 500,
			}}
		/>
	);
};

export default ChipComponent;
